module.exports = __webpack_public_path__ + "img/HZ-B5106.5ad06d18.jpg";